export const sectionDataValues = (sectionList) => {
    let sectionListData = [];
    sectionList.forEach((item, index, element) => {
        sectionListData.push({ sectionTemplateName: item.name, sectionTemplateId: item.id, rate: 0 })
    })
    return sectionListData.sort(function (a, b) {
        var textA = a.sectionTemplateName.toUpperCase();
        var textB = b.sectionTemplateName.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
}

export const getTotalUsersCount = (userData) => {
    let count = 0;
    userData.forEach((item, index, element) => {
        if (item.enabled) {
            count++
        }
    })
    return count
}

export const getSelectedSectionData = (sectionData) => {
    let selectedSectionData = []
    sectionData.forEach((item, index, element) => {
        if (item.rate > 0) {
            selectedSectionData.push(item)
        }
    })
    return selectedSectionData
}

export const updateSectionDataValue = (entityDetails, editSectionData) => {
    entityDetails.correspondentEntity.offerings.forEach((item) => {
        editSectionData.forEach(section => {
            if (item.sectionTemplateId === section.sectionTemplateId) {
                section.rate = item.rate
            }
        })
    })
    return editSectionData;
}

export const getRequestBody = (entityDetails, userDetails, sectionDetails) => {
    const tempRequestBody = {
        correspondentEntity: {
            ...entityDetails,
            offerings: sectionDetails
        },
        correspondentUsersList: userDetails
    }
    return tempRequestBody;
}

export const setEntityDetails = (entityDetails) => {
    const tempEntityDetails = {
        address: entityDetails.address,
        city: entityDetails.city,
        pinCode: entityDetails.pinCode,
        correspondentEntityName: entityDetails.correspondentEntityName,
        gstNum: entityDetails.gstNum,
        panNo: entityDetails.panNo,
        state: entityDetails.state,
        id: entityDetails.id
    }
    return tempEntityDetails
}

export const validateCorrespondentOnboarding = (entityDetails, userDetails) => {
    if (Object.keys(entityDetails).length > 0 && userDetails.length > 0) {
        return true
    } else {
        return false
    }
}